import React from "react"
import Relay from "react-relay"
import classnames from "classnames"
import PropTypes from "prop-types"
import { getImageSrcFromResource } from "../../scripts/resource"
import Image from "../elements/Image"

class ThumbnailGridItem extends React.Component {
  static defaultProps = {
    itemCount: 1
  }

  static propTypes = {
    resource: PropTypes.object.isRequired,
    itemCount: PropTypes.number,
    onClick: PropTypes.func
  }

  render() {
    const { resource, itemCount, onClick } = this.props
    const url = getImageSrcFromResource(resource, "small")

    return (
      <div
        className={classnames("thumbnail-grid__item", {
          "thumbnail-grid__item--multi": itemCount > 1
        })}
      >
        <a
          onClick={onClick}
          href={`/item/${resource.id}`}
          title={resource.title}
        >
          <div
            className="thumbnail-grid__item-inner"
            style={{ backgroundImage: 'url("' + url + '")' }}
          >
            <Image alt={resource.title} src={url} backgroundImage={true} />
          </div>
          {itemCount > 1 && (
            <span className="thumbnail-grid__item-pill">{itemCount}</span>
          )}
        </a>
      </div>
    )
  }
}

export default Relay.createContainer(ThumbnailGridItem, {
  fragments: {
    resource: () => Relay.QL`
      fragment on Resource {
        id
        title
        files {
          id
          type
          images {
            small { url height width }
          }
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/ThumbnailGridItem.js